import * as yup from "yup";

export const DeleteBookingSchema = yup.object().shape({
  cancel_date: yup.string().required("Data obrigatória"),
});
